export default __webpack_public_path__ + "static/images/exo-event3.png";